;(function () {
  'use strict'

  angular.module('contrast.current-server').constant('CURRENT_SERVER_EVENTS', {
    SERVER_CHANGE: 'server:change'
  })
})()
